"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cardClassNames: function() {
        return cardClassNames;
    },
    cardCSSVars: function() {
        return cardCSSVars;
    },
    useCardStyles_unstable: function() {
        return useCardStyles_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = require("@griffel/react");
const _reacttheme = require("@fluentui/react-theme");
const _react1 = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const cardClassNames = {
    root: 'fui-Card',
    floatingAction: 'fui-Card__floatingAction',
    checkbox: 'fui-Card__checkbox'
};
const cardCSSVars = {
    cardSizeVar: '--fui-Card--size',
    cardBorderRadiusVar: '--fui-Card--border-radius'
};
const focusOutlineStyle = {
    outlineRadius: `var(${cardCSSVars.cardBorderRadiusVar})`,
    outlineWidth: _reacttheme.tokens.strokeWidthThick,
    outlineOffset: '-2px'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "f1sil6mw",
        Bbmb7ep: [
            "fifeqxg",
            "f899z7z"
        ],
        Beyfa6y: [
            "f899z7z",
            "fifeqxg"
        ],
        B7oj6ja: [
            "f4h3tyx",
            "f18ur2pz"
        ],
        Btl43ni: [
            "f18ur2pz",
            "f4h3tyx"
        ],
        z8tnut: "f1lplnzb",
        z189sj: [
            "f10m5gbb",
            "f1k04kkk"
        ],
        Byoj8tv: "fhftqfp",
        uwmqm3: [
            "f1k04kkk",
            "f10m5gbb"
        ],
        i8kkvl: "fxsr4vj",
        Belr9w4: "fcvsdzp",
        mc9l5x: "f22iagw",
        qhf8xq: "f10pi13n",
        B7ck84d: "f1ewtqcl",
        sj55zd: "f19n0e5",
        E3zdtr: "f1mdlcz9",
        bn5sak: "frwkxtg",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        B1piin3: [
            "f15yvnhg",
            "f1n6gb5g"
        ],
        By385i5: "fo72kxq",
        Bsft5z2: "f13zj6fq",
        B80jsxd: "f1nwj1ja",
        Bm2nyyq: "f8rth92",
        Barhvk9: [
            "flthirb",
            "ftkbnf5"
        ],
        Bw17bha: "f1lh990p",
        vfts7: [
            "ftkbnf5",
            "flthirb"
        ],
        xrcqlc: "f6czdpx",
        Ihftqj: [
            "f13hvwk3",
            "f1en4csx"
        ],
        Bcgy8vk: "f1i1u9k0",
        Bhxzhr1: [
            "f1en4csx",
            "f13hvwk3"
        ],
        B3778ie: [
            "f1qnomq5",
            "f2fl922"
        ],
        d9w3h3: [
            "f2fl922",
            "f1qnomq5"
        ],
        Bl18szs: [
            "f1anhtl",
            "f1n2zcl3"
        ],
        B4j8arr: [
            "f1n2zcl3",
            "f1anhtl"
        ],
        B2jhnfs: "f16v3d5c"
    },
    focused: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bb7d1vk: "f226i61",
        zhwhgb: [
            "f13kzufm",
            "fsx75g8"
        ],
        dhy2o1: "flujwa2",
        Gfyso: [
            "fsx75g8",
            "f13kzufm"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        Bf4ptjt: "fh1cnn4",
        kclons: [
            "fy7oxxb",
            "f184ne2d"
        ],
        Bhdgwq3: "fpukqih",
        Blkhhs4: [
            "f184ne2d",
            "fy7oxxb"
        ],
        Bqtpl0w: "f99gebs",
        clg4pj: [
            "f13b0oaq",
            "f8t2bz6"
        ],
        hgwjuy: "f1jvq617",
        Bonggc9: [
            "f8t2bz6",
            "f13b0oaq"
        ],
        B1tsrr9: [
            "f11unbnk",
            "fbd201q"
        ],
        Dah5zi: [
            "fbd201q",
            "f11unbnk"
        ],
        Bkh64rk: [
            "f12nqxso",
            "f1uguk4w"
        ],
        qqdqy8: [
            "f1uguk4w",
            "f12nqxso"
        ],
        B6dhp37: "f1dvezut",
        i03rao: [
            "fd0oaoj",
            "f1cwg4i8"
        ],
        Boxcth7: "fjvm52t",
        Bsom6fd: [
            "f1cwg4i8",
            "fd0oaoj"
        ],
        J0r882: "f15fr7a0",
        Bule8hv: [
            "fwsq40z",
            "fy0y4wt"
        ],
        Bjwuhne: "f34ld9f",
        Ghsupd: [
            "fy0y4wt",
            "fwsq40z"
        ]
    },
    selectableFocused: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        Bssx7fj: "f1b1k54r",
        uh7if5: [
            "f4ne723",
            "fqqcjud"
        ],
        clntm0: "fh7aioi",
        Dlk2r6: [
            "fqqcjud",
            "f4ne723"
        ],
        Bm3wd5j: "f1k55ka9",
        Bbrhkcr: [
            "fgclinu",
            "f16pcs8n"
        ],
        f1oku: "fycbxed",
        aywvf2: [
            "f16pcs8n",
            "fgclinu"
        ],
        B2j2mmj: "ffht0p2",
        wigs8: "f1p0ul1q",
        pbfy6t: "f1c901ms",
        B0v4ure: "f1alokd7",
        ghq09: "f78i1la",
        B24cy0v: [
            "f1kvsw7t",
            "f1bw8brt"
        ],
        Bwckmig: "f8k7e5g",
        Bvwlmkc: [
            "f1bw8brt",
            "f1kvsw7t"
        ],
        Bbgo44z: "f125hn41",
        Bil7v7r: [
            "fgxkx34",
            "f1v56tyl"
        ],
        skfxo0: "fdxas6f",
        jo1ztg: [
            "f1v56tyl",
            "fgxkx34"
        ],
        Ba3ybja: [
            "fxwickw",
            "f1ia5cve"
        ],
        az1dzo: [
            "f1ia5cve",
            "fxwickw"
        ],
        vppk2z: [
            "f194aguw",
            "fqicc6c"
        ],
        B6352mv: [
            "fqicc6c",
            "f194aguw"
        ],
        nr063g: "fq4eyks",
        Blmvk6g: [
            "f1ya6x16",
            "ftuszwa"
        ],
        Bsiemmq: "f1e2iu44",
        B98u21t: [
            "ftuszwa",
            "f1ya6x16"
        ],
        B2pnrqr: "f1amxum7",
        B29w5g4: [
            "f1cec8w7",
            "f554mv0"
        ],
        Bhhzhcn: "f1sj6kbr",
        Bec0n69: [
            "f554mv0",
            "f1cec8w7"
        ]
    },
    orientationHorizontal: {
        Beiy3e4: "f1063pyq",
        Bt984gj: "f122n59",
        Bnoktp0: "fpfyeui",
        Idhjb2: "fwi74qw",
        ihgzqh: [
            "ffcmwrh",
            "f6ppoih"
        ],
        Bgp6ld0: [
            "f1dc9p14",
            "fd933vt"
        ],
        Bbucpmy: "f18esqgw"
    },
    orientationVertical: {
        Beiy3e4: "f1vx9l62",
        Bt4kzjz: [
            "fobhde4",
            "fx5r7kn"
        ],
        B1ou843: [
            "fx5r7kn",
            "fobhde4"
        ],
        y1433z: "f19chtn8",
        B7egwnw: "fuvs6re",
        B49b4xf: "fy4glsf"
    },
    sizeSmall: {
        B7balbw: "f1pi9uxy",
        B1h88n7: "f1h1zgly"
    },
    sizeMedium: {
        B7balbw: "frsmuga",
        B1h88n7: "fuldkky"
    },
    sizeLarge: {
        B7balbw: "f1qua4xo",
        B1h88n7: "fimkt6v"
    },
    filled: {
        De3pzq: "fxugw4r",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    filledInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "fxugw4r",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Jwef8y: "f1knas48",
        Bvxd0ez: "f1m145df",
        ecr2s2: "fb40n2d"
    },
    filledInteractiveSelected: {
        De3pzq: "f1nfm20t",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Jwef8y: "f1kz6goq"
    },
    filledAlternative: {
        De3pzq: "f1dmdbja",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    filledAlternativeInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "f1dmdbja",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Jwef8y: "f1uvynv3",
        Bvxd0ez: "f1m145df",
        ecr2s2: "f1yhgkbh"
    },
    filledAlternativeInteractiveSelected: {
        De3pzq: "fjxa0vh",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Jwef8y: "fehi0vp"
    },
    outline: {
        De3pzq: "f1c21dwh",
        E5pizo: "f1couhl3",
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ]
    },
    outlineInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "f1c21dwh",
        E5pizo: "f1couhl3",
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ],
        Jwef8y: "fjxutwb",
        Be0v6ae: "f1llr77y",
        B5kxglz: [
            "fzk0khw",
            "fjj8tog"
        ],
        B3pwyw6: "fb1u8ub",
        Bymgtzf: [
            "fjj8tog",
            "fzk0khw"
        ],
        ecr2s2: "fophhak",
        dmfk: "f1uohb70",
        B4ofi8: [
            "f1jm7v1n",
            "f1bus3rq"
        ],
        jgq6uv: "f1fbu7rr",
        Baxewws: [
            "f1bus3rq",
            "f1jm7v1n"
        ]
    },
    outlineInteractiveSelected: {
        De3pzq: "f1q9pm1r",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Jwef8y: "fg59vm4"
    },
    subtle: {
        De3pzq: "fhovq9v",
        E5pizo: "f1couhl3",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    subtleInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "fhovq9v",
        E5pizo: "f1couhl3",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Jwef8y: "f1t94bn6",
        ecr2s2: "f1wfn5kd"
    },
    subtleInteractiveSelected: {
        De3pzq: "fq5gl1p",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Jwef8y: "f1uqaxdt"
    },
    highContrastSelected: {
        ycbfsm: "fkc42ay",
        Bsw6fvg: "f1rirnrt",
        Bbusuzp: "f1lkg8j3",
        xgfqdd: "f1nkj0oa",
        Bmmdzwq: "fey3rwa",
        zkpvhj: [
            "f5jhx11",
            "fff9uym"
        ],
        B20bydw: "fm7n0jy",
        Bwwwggl: [
            "fff9uym",
            "f5jhx11"
        ]
    },
    highContrastInteractive: {
        h1vhog: "fpfvv3l",
        kslmdy: "f1oamsm6",
        Baaf6ca: "f1il21bs",
        x9zz3d: "fnn5dk0",
        Bmmdzwq: "fey3rwa",
        zkpvhj: [
            "f5jhx11",
            "fff9uym"
        ],
        B20bydw: "fm7n0jy",
        Bwwwggl: [
            "fff9uym",
            "f5jhx11"
        ]
    },
    select: {
        qhf8xq: "f1euv43f",
        Bhzewxz: "fqclxi7",
        j35jbq: [
            "fiv86kb",
            "f36uhnt"
        ],
        Bj3rh1h: "f19g0ac"
    },
    hiddenCheckbox: {
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "f1sil6mw",
        a9b677: "frkrog8",
        Bqenvij: "f1mpe4l3",
        qhf8xq: "f1euv43f",
        Bh84pgu: "fmf1zke",
        Bgl5zvf: "f1wch0ki",
        Huce71: "fz5stix"
    }
}, {
    d: [
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1sil6mw{overflow-y:hidden;}",
        ".fifeqxg{border-bottom-right-radius:var(--fui-Card--border-radius);}",
        ".f899z7z{border-bottom-left-radius:var(--fui-Card--border-radius);}",
        ".f4h3tyx{border-top-right-radius:var(--fui-Card--border-radius);}",
        ".f18ur2pz{border-top-left-radius:var(--fui-Card--border-radius);}",
        ".f1lplnzb{padding-top:var(--fui-Card--size);}",
        ".f10m5gbb{padding-right:var(--fui-Card--size);}",
        ".f1k04kkk{padding-left:var(--fui-Card--size);}",
        ".fhftqfp{padding-bottom:var(--fui-Card--size);}",
        ".fxsr4vj{column-gap:var(--fui-Card--size);}",
        ".fcvsdzp{row-gap:var(--fui-Card--size);}",
        ".f22iagw{display:flex;}",
        ".f10pi13n{position:relative;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1mdlcz9::after{position:absolute;}",
        ".frwkxtg::after{top:0;}",
        ".f1n6gb5g::after{left:0;}",
        ".f15yvnhg::after{right:0;}",
        ".fo72kxq::after{bottom:0;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1nwj1ja::after{pointer-events:none;}",
        ".f8rth92::after{border-top-style:solid;}",
        ".flthirb::after{border-right-style:solid;}",
        ".ftkbnf5::after{border-left-style:solid;}",
        ".f1lh990p::after{border-bottom-style:solid;}",
        ".f6czdpx::after{border-top-width:var(--strokeWidthThin);}",
        ".f13hvwk3::after{border-right-width:var(--strokeWidthThin);}",
        ".f1en4csx::after{border-left-width:var(--strokeWidthThin);}",
        ".f1i1u9k0::after{border-bottom-width:var(--strokeWidthThin);}",
        ".f1qnomq5::after{border-bottom-right-radius:var(--fui-Card--border-radius);}",
        ".f2fl922::after{border-bottom-left-radius:var(--fui-Card--border-radius);}",
        ".f1anhtl::after{border-top-right-radius:var(--fui-Card--border-radius);}",
        ".f1n2zcl3::after{border-top-left-radius:var(--fui-Card--border-radius);}",
        ".f16v3d5c>.fui-CardHeader,.f16v3d5c>.fui-CardFooter{flex-shrink:0;}",
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        ".fh1cnn4[data-fui-focus-visible]::after{border-top-style:solid;}",
        ".fy7oxxb[data-fui-focus-visible]::after{border-right-style:solid;}",
        ".f184ne2d[data-fui-focus-visible]::after{border-left-style:solid;}",
        ".fpukqih[data-fui-focus-visible]::after{border-bottom-style:solid;}",
        ".f99gebs[data-fui-focus-visible]::after{border-top-width:var(--strokeWidthThick);}",
        ".f13b0oaq[data-fui-focus-visible]::after{border-right-width:var(--strokeWidthThick);}",
        ".f8t2bz6[data-fui-focus-visible]::after{border-left-width:var(--strokeWidthThick);}",
        ".f1jvq617[data-fui-focus-visible]::after{border-bottom-width:var(--strokeWidthThick);}",
        ".f11unbnk[data-fui-focus-visible]::after{border-bottom-right-radius:var(--fui-Card--border-radius);}",
        ".fbd201q[data-fui-focus-visible]::after{border-bottom-left-radius:var(--fui-Card--border-radius);}",
        ".f12nqxso[data-fui-focus-visible]::after{border-top-right-radius:var(--fui-Card--border-radius);}",
        ".f1uguk4w[data-fui-focus-visible]::after{border-top-left-radius:var(--fui-Card--border-radius);}",
        ".f1dvezut[data-fui-focus-visible]::after{border-top-color:var(--colorStrokeFocus2);}",
        ".fd0oaoj[data-fui-focus-visible]::after{border-right-color:var(--colorStrokeFocus2);}",
        ".f1cwg4i8[data-fui-focus-visible]::after{border-left-color:var(--colorStrokeFocus2);}",
        ".fjvm52t[data-fui-focus-visible]::after{border-bottom-color:var(--colorStrokeFocus2);}",
        ".f15fr7a0[data-fui-focus-visible]::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".fwsq40z[data-fui-focus-visible]::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".fy0y4wt[data-fui-focus-visible]::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f34ld9f[data-fui-focus-visible]::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1b1k54r[data-fui-focus-within]:focus-within{border-top-color:transparent;}",
        ".f4ne723[data-fui-focus-within]:focus-within{border-right-color:transparent;}",
        ".fqqcjud[data-fui-focus-within]:focus-within{border-left-color:transparent;}",
        ".fh7aioi[data-fui-focus-within]:focus-within{border-bottom-color:transparent;}",
        ".ffht0p2[data-fui-focus-within]:focus-within::after{content:\"\";}",
        ".f1p0ul1q[data-fui-focus-within]:focus-within::after{position:absolute;}",
        ".f1c901ms[data-fui-focus-within]:focus-within::after{pointer-events:none;}",
        ".f1alokd7[data-fui-focus-within]:focus-within::after{z-index:1;}",
        ".f78i1la[data-fui-focus-within]:focus-within::after{border-top-style:solid;}",
        ".f1kvsw7t[data-fui-focus-within]:focus-within::after{border-right-style:solid;}",
        ".f1bw8brt[data-fui-focus-within]:focus-within::after{border-left-style:solid;}",
        ".f8k7e5g[data-fui-focus-within]:focus-within::after{border-bottom-style:solid;}",
        ".f125hn41[data-fui-focus-within]:focus-within::after{border-top-width:var(--strokeWidthThick);}",
        ".fgxkx34[data-fui-focus-within]:focus-within::after{border-right-width:var(--strokeWidthThick);}",
        ".f1v56tyl[data-fui-focus-within]:focus-within::after{border-left-width:var(--strokeWidthThick);}",
        ".fdxas6f[data-fui-focus-within]:focus-within::after{border-bottom-width:var(--strokeWidthThick);}",
        ".fxwickw[data-fui-focus-within]:focus-within::after{border-bottom-right-radius:var(--fui-Card--border-radius);}",
        ".f1ia5cve[data-fui-focus-within]:focus-within::after{border-bottom-left-radius:var(--fui-Card--border-radius);}",
        ".f194aguw[data-fui-focus-within]:focus-within::after{border-top-right-radius:var(--fui-Card--border-radius);}",
        ".fqicc6c[data-fui-focus-within]:focus-within::after{border-top-left-radius:var(--fui-Card--border-radius);}",
        ".fq4eyks[data-fui-focus-within]:focus-within::after{border-top-color:var(--colorStrokeFocus2);}",
        ".f1ya6x16[data-fui-focus-within]:focus-within::after{border-right-color:var(--colorStrokeFocus2);}",
        ".ftuszwa[data-fui-focus-within]:focus-within::after{border-left-color:var(--colorStrokeFocus2);}",
        ".f1e2iu44[data-fui-focus-within]:focus-within::after{border-bottom-color:var(--colorStrokeFocus2);}",
        ".f1amxum7[data-fui-focus-within]:focus-within::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1cec8w7[data-fui-focus-within]:focus-within::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f554mv0[data-fui-focus-within]:focus-within::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1sj6kbr[data-fui-focus-within]:focus-within::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1063pyq{flex-direction:row;}",
        ".f122n59{align-items:center;}",
        ".fpfyeui>.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".fwi74qw>.fui-CardPreview{margin-bottom:calc(var(--fui-Card--size) * -1);}",
        ".ffcmwrh>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".f6ppoih>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".f1dc9p14>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".fd933vt>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".f18esqgw>.fui-CardHeader:last-of-type,.f18esqgw>.fui-CardFooter:last-of-type{flex-grow:1;}",
        ".f1vx9l62{flex-direction:column;}",
        ".fobhde4>.fui-CardPreview{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".fx5r7kn>.fui-CardPreview{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".f19chtn8>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".fuvs6re>.fui-Card__floatingAction+.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".fy4glsf>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-bottom:calc(var(--fui-Card--size) * -1);}",
        ".f1pi9uxy{--fui-Card--size:8px;}",
        ".f1h1zgly{--fui-Card--border-radius:var(--borderRadiusSmall);}",
        ".frsmuga{--fui-Card--size:12px;}",
        ".fuldkky{--fui-Card--border-radius:var(--borderRadiusMedium);}",
        ".f1qua4xo{--fui-Card--size:16px;}",
        ".fimkt6v{--fui-Card--border-radius:var(--borderRadiusLarge);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1whvlc6{box-shadow:var(--shadow4);}",
        ".f16gxe2i::after{border-top-color:var(--colorTransparentStroke);}",
        ".fpgykix::after{border-right-color:var(--colorTransparentStroke);}",
        ".fzybk4o::after{border-left-color:var(--colorTransparentStroke);}",
        ".f1osi826::after{border-bottom-color:var(--colorTransparentStroke);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}",
        ".f16eln5f::after{border-top-color:var(--colorNeutralStroke1Selected);}",
        ".fa2okxs::after{border-right-color:var(--colorNeutralStroke1Selected);}",
        ".fg4zq3l::after{border-left-color:var(--colorNeutralStroke1Selected);}",
        ".ff6932p::after{border-bottom-color:var(--colorNeutralStroke1Selected);}",
        ".f1dmdbja{background-color:var(--colorNeutralBackground2);}",
        ".fjxa0vh{background-color:var(--colorNeutralBackground2Selected);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1couhl3{box-shadow:none;}",
        ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}",
        ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}",
        ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}",
        ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1euv43f{position:absolute;}",
        ".fqclxi7{top:4px;}",
        ".fiv86kb{right:4px;}",
        ".f36uhnt{left:4px;}",
        ".f19g0ac{z-index:1;}",
        ".frkrog8{width:1px;}",
        ".f1mpe4l3{height:1px;}",
        ".fmf1zke{clip:rect(0 0 0 0);}",
        ".f1wch0ki{clip-path:inset(50%);}",
        ".fz5stix{white-space:nowrap;}"
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f226i61[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f13kzufm[data-fui-focus-visible]::after{border-right-color:Highlight;}.fsx75g8[data-fui-focus-visible]::after{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.flujwa2[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1k55ka9[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16pcs8n[data-fui-focus-within]:focus-within::after{border-left-color:Highlight;}.fgclinu[data-fui-focus-within]:focus-within::after{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fycbxed[data-fui-focus-within]:focus-within::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1nkj0oa .fui-CardPreview,.f1nkj0oa .fui-CardFooter{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fey3rwa::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f5jhx11::after{border-right-color:Highlight;}.fff9uym::after{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fm7n0jy::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fpfvv3l:hover,.fpfvv3l :active{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1oamsm6:hover,.f1oamsm6 :active{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1il21bs:hover,.f1il21bs :active{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fnn5dk0:hover .fui-CardPreview,.fnn5dk0 :active .fui-CardPreview,.fnn5dk0:hover .fui-CardFooter,.fnn5dk0 :active .fui-CardFooter{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    h: [
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".f1m145df:hover{box-shadow:var(--shadow8);}",
        ".f1kz6goq:hover{background-color:var(--colorNeutralBackground1Selected);}",
        ".f1uvynv3:hover{background-color:var(--colorNeutralBackground2Hover);}",
        ".fehi0vp:hover{background-color:var(--colorNeutralBackground2Selected);}",
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f1llr77y:hover::after{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".fzk0khw:hover::after{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".fjj8tog:hover::after{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".fb1u8ub:hover::after{border-bottom-color:var(--colorNeutralStroke1Hover);}",
        ".fg59vm4:hover{background-color:var(--colorTransparentBackgroundSelected);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".f1uqaxdt:hover{background-color:var(--colorSubtleBackgroundSelected);}"
    ],
    a: [
        ".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".f1yhgkbh:active{background-color:var(--colorNeutralBackground2Pressed);}",
        ".fophhak:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f1uohb70:active::after{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1jm7v1n:active::after{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f1bus3rq:active::after{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1fbu7rr:active::after{border-bottom-color:var(--colorNeutralStroke1Pressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"
    ]
});
const useCardStyles_unstable = (state)=>{
    const styles = useStyles();
    const orientationMap = {
        horizontal: styles.orientationHorizontal,
        vertical: styles.orientationVertical
    };
    const sizeMap = {
        small: styles.sizeSmall,
        medium: styles.sizeMedium,
        large: styles.sizeLarge
    };
    const appearanceMap = {
        filled: styles.filled,
        'filled-alternative': styles.filledAlternative,
        outline: styles.outline,
        subtle: styles.subtle
    };
    const selectedMap = {
        filled: styles.filledInteractiveSelected,
        'filled-alternative': styles.filledAlternativeInteractiveSelected,
        outline: styles.outlineInteractiveSelected,
        subtle: styles.subtleInteractiveSelected
    };
    const interactiveMap = {
        filled: styles.filledInteractive,
        'filled-alternative': styles.filledAlternativeInteractive,
        outline: styles.outlineInteractive,
        subtle: styles.subtleInteractive
    };
    const isSelectableOrInteractive = state.interactive || state.selectable;
    const focusedClassName = _react1.useMemo(()=>{
        if (state.selectable) {
            if (state.selectFocused) {
                return styles.selectableFocused;
            }
            return '';
        }
        return styles.focused;
    }, [
        state.selectFocused,
        state.selectable,
        styles.focused,
        styles.selectableFocused
    ]);
    state.root.className = (0, _react.mergeClasses)(cardClassNames.root, styles.root, orientationMap[state.orientation], sizeMap[state.size], appearanceMap[state.appearance], isSelectableOrInteractive && interactiveMap[state.appearance], state.selected && selectedMap[state.appearance], // Focus overrides
    focusedClassName, // High contrast overrides
    isSelectableOrInteractive && styles.highContrastInteractive, state.selected && styles.highContrastSelected, state.root.className);
    if (state.floatingAction) {
        state.floatingAction.className = (0, _react.mergeClasses)(cardClassNames.floatingAction, styles.select, state.floatingAction.className);
    }
    if (state.checkbox) {
        state.checkbox.className = (0, _react.mergeClasses)(cardClassNames.checkbox, styles.hiddenCheckbox, state.checkbox.className);
    }
    return state;
}; //# sourceMappingURL=useCardStyles.styles.js.map
